import React from 'react';

export default function RedTracky() {
  return (
    <svg
      width='32'
      height='32'
      viewBox='0 0 32 32'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 12.8C0 8.31958 0 6.07937 0.871948 4.36808C1.63893 2.86278 2.86278 1.63893 4.36808 0.871948C6.07937 0 8.31958 0 12.8 0H19.2C23.6804 0 25.9206 0 27.6319 0.871948C29.1372 1.63893 30.3611 2.86278 31.1281 4.36808C32 6.07937 32 8.31958 32 12.8V19.2C32 23.6804 32 25.9206 31.1281 27.6319C30.3611 29.1372 29.1372 30.3611 27.6319 31.1281C25.9206 32 23.6804 32 19.2 32H12.8C8.31958 32 6.07937 32 4.36808 31.1281C2.86278 30.3611 1.63893 29.1372 0.871948 27.6319C0 25.9206 0 23.6804 0 19.2V12.8Z'
        fill='url(#paint0_linear_5201_5650)'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M16.2454 6.50928C21.9037 6.50928 26.4908 11.0964 26.4908 16.7546C26.4908 22.4131 21.9037 27.0001 16.2454 27.0001C10.587 27.0001 6 22.4131 6 16.7546C6 11.0964 10.587 6.50928 16.2454 6.50928ZM16.2454 11.3883C19.2092 11.3883 21.6117 13.791 21.6117 16.7546C21.6117 19.7186 19.2092 22.1211 16.2454 22.1211C13.2816 22.1211 10.8789 19.7186 10.8789 16.7546C10.8789 13.791 13.2816 11.3883 16.2454 11.3883Z'
        fill='#E9E9E9'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M16.6228 12.9309C16.4139 12.9057 16.251 12.7306 16.2454 12.5164V12.5157V5.94538C16.2454 5.8787 16.2447 5.81196 16.2456 5.74527C16.2578 5.33193 16.5968 5 17.0134 5C17.0359 5 17.0585 5.00115 17.0805 5.00289C17.095 5.00397 17.1083 5.00491 17.1224 5.00592C22.9364 5.41779 27.629 10.1345 27.9986 15.9395C27.9995 15.9551 28.0001 15.9706 28.0001 15.9863C28.0001 16.3588 27.7348 16.6692 27.383 16.7393C27.344 16.747 27.2981 16.7533 27.2582 16.7542L20.5064 16.7546H20.4999H20.4953C20.2715 16.7546 20.088 16.5833 20.0678 16.3649C19.8849 14.5501 18.4392 13.1081 16.6227 12.9311L16.6228 12.9309Z'
        fill='#FF473D'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5201_5650'
          x1='16'
          y1='0'
          x2='16'
          y2='32'
          gradientUnits='userSpaceOnUse'
        >
          <stop stop-color='#3C3D47' />
          <stop offset='1' stop-color='#2A2A2F' />
        </linearGradient>
      </defs>
    </svg>
  );
}
